import { Grid, Button, Box, Typography } from "@mui/material";
import { useFormik } from "formik";
import "./style.css";
import { useErrorHandler } from "../../../hooks";
import { useEffect, useState } from "react";
import Productmobile from "../../../Assets/Images/Product-mobile.png";
import { useDispatch, useSelector } from "react-redux";
import { uploadSandBox } from "../../../Redux/Actions/ProgramAction";
import LeftArrow from "../../../Assets/Images/left-arrow.png";
import { useNavigate } from "react-router";
import rightArrow from "../../../Assets/Images/right-arrow.png";
import parse from "html-react-parser";

export function PreviewForm({ setStepOneData, _handleBack, formValue }) {
  const navigate = useNavigate();
  const { setMsgConfig } = useErrorHandler();
  const dispatch = useDispatch();

  //getting program details
  const { success, sandbox, isEdit, getProgramDetails, createProgram } =
    useSelector((state) => state?.Program);

  //state
  const [dayId, setDayId] = useState(1);
  const [dayDetails, setDayDetails] = useState({});
  const [programsDetails, setProgramsDetails] = useState({
    id: "",
    duration: "",
  });

  //set program details
  useEffect(() => {
    !isEdit &&
      createProgram?.programDetails &&
      createProgram?.programDetails?.map((item) => {
        setProgramsDetails({
          id: item.id,
          duration: item.duration,
        });
      });
    if (isEdit && getProgramDetails) {
      setProgramsDetails({ id: getProgramDetails?.id });
    }

    createProgram?.programCommitments &&
      createProgram?.programCommitments?.map((item) => {
        item.day === dayId && setDayDetails(item);
      });

    getProgramDetails &&
      getProgramDetails?.commitments &&
      getProgramDetails?.commitments?.map((item) => {
        item.day === dayId && setDayDetails(item);
      });
  }, [
    createProgram?.programDetails,
    getProgramDetails,
    dayId,
    createProgram?.programCommitments,
  ]);

  //form handle
  const handleSubmit = () => {
    if (programsDetails) {
      const payload = {
        program_id: programsDetails?.id,
      };
      dispatch(uploadSandBox(payload));
      setMsgConfig({
        alertOpen: true,
        message: "Something went wrong!!",
        severity: "error",
        autoHideDuration: 2000,
      });
    }
  };

  useEffect(() => {
    if (success && sandbox) {
      navigate("/programs", { state: "SANDBOX" });
    }
  }, [dispatch, success]);

  return (
    <>
      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          sx={{ mt: 3, ml: 2 }}
          exact={`${true}`}
          direction-xs-row-reverse
        >
          Day
        </Grid>
        <Grid
          item
          xs={12}
          exact={`${true}`}
          direction-xs-row-reverse
          className="heelo"
        >
          {(() => {
            const buttons = [];
            for (
              let i = 0;
              isEdit && getProgramDetails?.duration
                ? i < getProgramDetails?.duration * 7
                : programsDetails && programsDetails?.duration
                ? i < programsDetails?.duration * 7
                : null;
              i++
            ) {
              buttons.push(
                <Button
                  type="submit"
                  className={dayId === i + 1 ? "select-day-btn" : "day-btn"}
                  key={i}
                  onClick={() => {
                    setDayId(i + 1);
                  }}
                >
                  {i + 1}
                </Button>
              );
            }
            return buttons;
          })()}
        </Grid>
        <Box className="mobile-section">
          <img src={Productmobile} className="product-image" alt="" />
          <Box className="mobile-scroll">
            <Box className="mobile-scroll-inner">
              {dayDetails?.commitment_details?.length !== 0 &&
                dayDetails?.commitment_details?.map((item) => {
                  return (
                    <>
                      <Box className="today-heading">
                        <br />
                        {item.commitment_title}
                      </Box>
                      <Box className="card-scroll">
                        <Box className="card-scroll-image">
                          <img src={item.cover_img} alt="" />
                        </Box>
                        <Typography className="first-heading">
                          Next Commitment
                        </Typography>
                        <Typography className="last-heading">
                          {item.short_description} <br />
                          {item?.description
                            ? parse(
                                item?.description?.replace(
                                  "<img",
                                  `<img width="150px" height="200px" align="center"`
                                )
                              )
                            : ""}
                        </Typography>
                        <Box className="fullwidth">
                          <Button variant="contained">View</Button>
                        </Box>
                      </Box>
                    </>
                  );
                })}
            </Box>
          </Box>
        </Box>

        <Grid item xs={12}>
          <Button
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              lineHeight: "0px",
              padding: "13px 30px !important",
            }}
            variant="contained"
            className="program-previous-btn"
            onClick={_handleBack}
          >
            <img src={LeftArrow} alt="" />
            <span>Previous</span>
          </Button>
          <Button
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              lineHeight: "0px",
              padding: "13px 30px !important",
            }}
            className="program-next-btn"
            variant="contained"
            // onClick={formik.handleSubmit}
            onClick={handleSubmit}
          >
            <span>UPLOAD TO SANDBOX</span>
            <img src={rightArrow} alt="" />
          </Button>
        </Grid>
      </Grid>
    </>
  );
}
